import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'fury-apploader',
  templateUrl: './apploader.component.html',
  styleUrls: ['./apploader.component.scss']
})
export class ApploaderComponent implements OnInit {

  title;
  message;
  constructor(public dialogRef: MatDialogRef<ApploaderComponent>) {}

  ngOnInit() {
  }

}
